const EFFECTIVE_TYPE_ORDER = {
    'slow-2g': 0,
    '2g': 1,
    '3g': 2,
    '4g': 3,
};
export const isEffectivelyOnline = (threshold) => { var _a, _b; return window.navigator.onLine &&
    (!((_a = window.navigator.connection) === null || _a === void 0 ? void 0 : _a.effectiveType) ||
        EFFECTIVE_TYPE_ORDER[(_b = window.navigator.connection) === null || _b === void 0 ? void 0 : _b.effectiveType] >=
            EFFECTIVE_TYPE_ORDER[threshold]); };
export const registerNetworkStatusCallback = (threshold, callback, debounceTime) => {
    callback(isEffectivelyOnline(threshold));
    let lastTimer;
    const onlineHandler = () => {
        if (lastTimer)
            clearTimeout(lastTimer);
        lastTimer = undefined;
        lastTimer = window.setTimeout(() => callback(true), debounceTime);
    };
    const offlineHandler = () => {
        if (lastTimer)
            clearTimeout(lastTimer);
        lastTimer = undefined;
        callback(false);
    };
    const changeHandler = () => isEffectivelyOnline(threshold) ? onlineHandler() : offlineHandler();
    if (window.navigator.connection) {
        window.navigator.connection.addEventListener('change', changeHandler);
    }
    else {
        window.addEventListener('offline', offlineHandler);
        window.addEventListener('online', onlineHandler);
    }
    return () => {
        if (window.navigator.connection) {
            window.navigator.connection.removeEventListener('change', changeHandler);
        }
        else {
            window.removeEventListener('offline', offlineHandler);
            window.removeEventListener('online', onlineHandler);
        }
    };
};
